import { render } from "./Comics.vue?vue&type=template&id=2d5e9126"
import script from "./Comics.vue?vue&type=script&lang=js"
export * from "./Comics.vue?vue&type=script&lang=js"

import exportComponent from "/opt/root/mangareader/reader/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__